
import { defineComponent } from 'vue'

/**
 * 省略表示コンポーネント
 * ツールチップでも出す
 */
export default defineComponent({
  name: 'TextOmit',
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
  },
})
